'use client';

import type { FeatureFlagAdapter } from './adapter.types';
import { FliptAdapter } from './flipt.adapter';
import { getE2EFeatureFlagSnapshot, StaticFeatureFlagAdapter } from './static.adapter';

import { getFliptConfig } from '@/feature-flags/config';

export function createDefaultAdapter(): FeatureFlagAdapter {
  const snapshot = getE2EFeatureFlagSnapshot();

  if (snapshot) {
    return new StaticFeatureFlagAdapter(snapshot);
  }

  const { url, apiToken } = getFliptConfig();

  if (!url) {
    throw new Error('Flipt URL is required to create the feature flag adapter');
  }

  return new FliptAdapter({ url, apiToken });
}
